module.exports = __webpack_public_path__ + "static/hydrandea-paniculata-0-bd831a3fad530a745e833e8a25265a60.png";